"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeScanPayloadMetrics = void 0;
function computeScanPayloadMetrics(scanResults) {
    const bytes = (v) => Buffer.byteLength(JSON.stringify(v), "utf8");
    return {
        scanResultCount: scanResults.length,
        applicationScanResultCount: Math.max(0, scanResults.length - 1),
        scanResultPayloadBytes: scanResults.map(bytes),
        totalScanResultsPayloadBytes: bytes(scanResults),
    };
}
exports.computeScanPayloadMetrics = computeScanPayloadMetrics;
//# sourceMappingURL=scan-payload-metrics.js.map